<template>
  <article
    :class="bemBlock"
  >
    <p
      :class="bemElement('title', { 'disabled': isDisabled })"
    >
      {{ $msg('button.stockalert', 'product') }}
    </p>
    <div v-if="!isDisabled">
      <p
        v-if="stockAlertSize && stockAlertSize.id !== '' && stockAlertSize.id !== 'UN'"
        v-show="!hiddenForm"
        :class="bemElement('explanation')"
      >
        {{ $msg('stockalert.explanation', 'product', [stockAlertSize.displayValue]) }}
      </p>
      <p
        v-else
        v-show="!hiddenForm"
        :class="bemElement('explanation')"
      >
        {{ $msg('stockalert.explanation.singleSize', 'product') }}
      </p>
      <form
        v-show="!hiddenForm"
        ref="notifyForm"
        :class="bemElement('form')"
        novalidate
        @submit.prevent="onSubmit"
      >
        <BaseFieldText
          id="stock-alert-popup-mail"
          ref="email"
          v-model="email"
          bem="stock-alert-popup-mail"
          :class="bemElement('mail')"
          name="stock-alert-popup-mail"
          input-type="email"
          type="primary"
          :label="$msg('label.input.email', 'forms')"
          :pattern="emailRegex"
          :error-messages="{
            patternMismatch: $msg('error.message.parse.email.profile.form', 'forms'),
          }"
        />
        <button
          v-show="stockAlertVisible || isBreakpointDesktop"
          type="submit"
          :class="[
            bemElement('form-submit'),
            isBreakpointMobile ? 'btn--cta' : 'btn--primary interaction--enable-disable-form-v1',
            'btn',
            { disabled: disableSubmit },
          ]"
        >
          <span>
            {{ $msg('stockalert.submit', 'product') }}
          </span>
        </button>
      </form>
      <p
        v-show="message.visible"
        ref="message"
        :class="bemElement('message', message.modifier)"
      >
        {{ message.text }}
      </p>
      <button
        v-show="message.visible && message.modifier === 'success' && isBreakpointMobile"
        type="button"
        :class="[
          bemElement('success-button'),
          'btn--cta',
          'btn',
        ]"
      >
        <span>
          {{ $msg('stockalert.success', 'product') }}
        </span>
      </button>
    </div>
  </article>
</template>

<script>
import Axios from 'axios';
import bemClassesMixin from '../mixins/bemClassesMixin';
import productPropSizesMixin from '../mixins/productPropSizesMixin';
import BaseFieldText from './forms/BaseFieldText.vue';
import clientSideValidation from '../../components/clientSideValidation';
import windowResizeMixin from '../mixins/windowResizeMixin';
import { getVariationGroupId } from '../../common/helpers/productIdHelpers';
import getAnalyticsEventCenter from '../../common/getAnalyticsEventCenter';
import getFrontConfig from '../../common/getFrontConfig';

const analyticsEventCenter = getAnalyticsEventCenter();

const {
  emailRegex,
  responsive: {
    bp_575: bp575,
  },
  urls: {
    stockAlertSubscribeUrl,
  },
} = getFrontConfig();

export default {
  name: 'TheProductDetailsStockAlert',

  components: {
    BaseFieldText,
  },

  mixins: [
    bemClassesMixin,
    productPropSizesMixin,
    windowResizeMixin,
  ],

  props: {
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    stockAlertVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    stockAlertSize: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      emailRegex,
      stockAlertSubscribeUrl,
      message: {
        visible: false,
        modifier: '',
        text: this.$msg('error.unexpected', 'forms'),
      },
      email: '',
      hiddenForm: false,
      dataChangeBreakpoint: bp575,
    };
  },

  computed: {
    disableSubmit() {
      return this.email === ''
        || this.stockAlertSize?.id === ''
        || this.product?.id === '';
    },
  },

  watch: {
    stockAlertVisible() {
      this.handleInputFocus();
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.handleInputFocus();
    });
  },

  methods: {
    onSubmit() {
      if (
        !this.stockAlertVisible
        || this.disableSubmit
      ) {
        return;
      }

      const form = this.$refs.notifyForm;
      const isFormValid = clientSideValidation.functions.validateFormatData(form);

      if (isFormValid) {
        const formData = {
          email: this.email,
          pid: getVariationGroupId(this.product.id),
          size_id: this.stockAlertSize?.id,
        };

        Axios.post(this.stockAlertSubscribeUrl,
          formData,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then((response) => {
            this.message.visible = true;
            this.message.text = response.data.msg;
            if (response.data.success) {
              this.message.modifier = 'success';
              // Send info for analytics
              analyticsEventCenter.publish(analyticsEventCenter.EVENTS.stockAlertSent);
              this.hiddenForm = true;
              this.email = '';
              setTimeout(() => {
                this.$emit('stock-alert:hide', { uncheckSizeInputs: true });
                this.hiddenForm = false;
                this.message.visible = false;
              }, 3000);
            } else {
              this.message.modifier = 'error';
              this.hiddenForm = false;
            }
          })
          .catch(() => {
            this.message.visible = true;
            this.message.modifier = 'error';
          });
      }
    },
    handleInputFocus() {
      if (this.$refs.email) {
        // Send info for analytics
        analyticsEventCenter.publish(analyticsEventCenter.EVENTS.stockAlertOpened);
        setTimeout(() => {
          if (this.$refs.email) {
            if (this.stockAlertVisible) {
              this.$refs.email.focus();
            } else {
              this.$refs.email.blur();
            }
          }
        }, 400);
      }
    },
  },
};
</script>
